import { CoatingAreaComponentWidget } from "../component/Widget/CoatingAreaComponentWidget";
import { CoatingsComponentWidget } from "../component/Widget/CoatingsComponentWidget";
import { FloorCoatingAreaComponentWidget } from "../component/Widget/FloorCoatingAreaComponentWidget";
import { FunctionalityComponentWidget } from "../component/Widget/FunctionalityComponentWidget";
import { JoineryTypeComponentWidget } from "../component/Widget/JoineryTypeComponentWidget";
import { TechnicalElementsComponentWidget } from "../component/Widget/TechnicalElementsComponentWidget";
import { ActionStateEnum } from "../../cocos/scripts/state/actionState/ActionState";
import { PlanManager } from "../../cocosPlan";
import { FloorCoatingAreaState } from "../../cocos/scripts/state";
import { Coating, CoatingArea, Commands, Component, ComponentConstants, Entity, Events, eventsManager, FloorCoatingArea, Functionality, JoineryType, Listener, TechnicalElementType } from "@rhinov/savane-js";

export class ComponentPanelController {

    widgetTab: Array<CoatingAreaComponentWidget | CoatingsComponentWidget | FloorCoatingAreaComponentWidget | FunctionalityComponentWidget | JoineryTypeComponentWidget | TechnicalElementsComponentWidget> = [];

    draggingTulip: boolean = false;
    lastPositionX: number = 0;
    lastPositionY: number = 0;
    removelistener: Listener | null;

    element = document.getElementById("panelCompMovable") as HTMLElement;
        

    mousedown = (event: MouseEvent) => {
        if (event.button === 0) {
            if (event.layerY <= 32) {
                this.lastPositionX = event.x;
                this.lastPositionY = event.y;
                this.draggingTulip = true;
            }
        }
    }

    mouseup = (event: MouseEvent) => {
        if (event.button === 0) {
            this.draggingTulip = false;
        }
    }

    mousemove = (event: MouseEvent) => {
        if (this.draggingTulip) {
            var deltaX = event.x - this.lastPositionX;
            var deltaY = event.y - this.lastPositionY;

            this.lastPositionX = event.x;
            this.lastPositionY = event.y;

            var offset = {left: this.element.offsetLeft,  top: this.element.offsetTop};

            offset.left += deltaX;
            offset.top += deltaY;

            this.element.style.top = offset.top + 'px';
            this.element.style.left = offset.left + 'px';
        }
    }

    mouseleave = (event: MouseEvent) => {
        if (this.draggingTulip) {
            var deltaX = event.x - this.lastPositionX;
            var deltaY = event.y - this.lastPositionY;

            this.lastPositionX = event.x;
            this.lastPositionY = event.y;

            var offset = {left: this.element.offsetLeft,  top: this.element.offsetTop};

            offset.left += deltaX;
            offset.top += deltaY;

            this.element.style.top = offset.top + 'px';
            this.element.style.left = offset.left + 'px';
        }
    }

    resize = () => {
        setTimeout(() => {
            var panel = document.getElementById('panelCompMovable');
            if (!panel) return;
            panel.style.top = "100px";
            panel.style.left = "100px";
            var maxWidth = panel.getBoundingClientRect().width;
            var maxHeight = panel.getBoundingClientRect().height;
            panel.style.top = (window.innerHeight - maxHeight) / 2 + 54 + 'px';
            panel.style.left = (window.innerWidth - maxWidth) / 2 + 'px';
        });
    }
    
    constructor (entity: Entity, config: any) {

        this.element.addEventListener("mousedown", this.mousedown);
        this.element.addEventListener("mouseup", this.mouseup);
        this.element.addEventListener("mousemove", this.mousemove);
        this.element.addEventListener("mouseleave", this.mousemove);
        
        var sortedComponents = entity.components.sort((a: Component, b: Component) => a.componentType! - b.componentType!);
        
        var i;
        var end = 0;
        for (i = 0; i < sortedComponents.length; i++) {
            switch (sortedComponents[i].componentType) {
                case ComponentConstants.ComponentType.Functionality:
                    if (config.componentType === ComponentConstants.ComponentType.Functionality) {
                        this.widgetTab.push(new FunctionalityComponentWidget(sortedComponents[i] as Functionality, this.widgetTab.length));
                    }
                    break;
                case ComponentConstants.ComponentType.JoineryType:
                    if (config.componentType === ComponentConstants.ComponentType.JoineryType) {
                        this.widgetTab.push(new JoineryTypeComponentWidget(sortedComponents[i] as JoineryType, this.widgetTab.length));       
                    }
                    break;
                case ComponentConstants.ComponentType.TechnicalElementType:
                    if (config.componentType === ComponentConstants.ComponentType.TechnicalElementType) {
                        this.widgetTab.push(new TechnicalElementsComponentWidget(sortedComponents[i] as TechnicalElementType, this.widgetTab.length));            
                    }
                    break;
                case ComponentConstants.ComponentType.Coating:
                    if (config.componentType === ComponentConstants.ComponentType.Coating) {
                        this.widgetTab.push(new CoatingsComponentWidget(sortedComponents[i] as Coating, this.widgetTab.length));
                    }
                    break;
                case ComponentConstants.ComponentType.CoatingArea:
                    if (config.componentType === ComponentConstants.ComponentType.CoatingArea) {
                        if (PlanManager.getInstance().frontViewLayer.isVisible()) {
                                var state = PlanManager.getInstance().state as unknown as FloorCoatingAreaState;

                                if (state.state === ActionStateEnum.FrontViewCoating && state._area === sortedComponents[i]) {
                                    this.widgetTab.push(new CoatingAreaComponentWidget(sortedComponents[i] as CoatingArea, this.widgetTab.length));
                                }
                            }
                    }
                    break;
                case ComponentConstants.ComponentType.FloorCoatingArea:
                    if (config.componentType === ComponentConstants.ComponentType.FloorCoatingArea) {
                        var state = PlanManager.getInstance().state as unknown as FloorCoatingAreaState;

                        if (state._area === sortedComponents[i]) {
                            this.widgetTab.push(new FloorCoatingAreaComponentWidget(sortedComponents[i] as FloorCoatingArea, this.widgetTab.length));
                        }
                        
                    }
                    break;
            }
        }
        this.widgetTab.forEach((widget) => {
            widget.init(() => {
                end++;
                if (end === this.widgetTab.length) {
                    var element = document.getElementById('innerPanelContainer');
                    if (element) element.innerHTML = this.setHTML();
                    let tulip = document.getElementById('component-panel');
                    if (tulip) {
                        tulip.classList.remove('hide');
                        this.resize();
                    }
                }
            });
        })

        this.removelistener = eventsManager.instance.addListener(Events.COMMAND_EXECUTED, async (event: any) => {
            switch (event.userData.name) {
                case Commands.CommandEnum.DeleteComponentCommand:
                    var component = event.userData.datas.component;
                    var id = -1;
                    for (var i = 0; i < this.widgetTab.length; i++) {
                        if (this.widgetTab[i].component === component) {
                            id = i;
                        }
                    }
                    this.widgetTab[id].destroy();
                    this.widgetTab.splice(id, 1);
                    if (this.widgetTab.length === 0) {
                        eventsManager.instance.dispatch(Events.HIDE_TULIP);
                    }
                    break;
            }
        });
    }

    setHTML(): string {
        var html = ""
        for (var i = 0; i < this.widgetTab.length; i++){
            html += this.widgetTab[i].html();
        }
        setTimeout(() => {
            for (var i = 0; i < this.widgetTab.length; i++){
                html += this.widgetTab[i].setListener();
            }
        }, 200);
        return html;
    }

    //On destroy
    destroy() {
        var i;
        for (i = 0; i < this.widgetTab.length; i++){
            this.widgetTab[i].destroy();
        }
        eventsManager.instance.removeListener(this.removelistener!);
        this.element.removeEventListener("mousedown", this.mousedown);
        this.element.removeEventListener("mouseup", this.mouseup);
        this.element.removeEventListener("mousemove", this.mousemove);
        this.element.removeEventListener("mouseleave", this.mousemove);
    }
}